import React from 'react';
import ReactDOM from 'react-dom';
import {ApolloProvider, ApolloClient} from '@apollo/client';
import {InMemoryCache} from '@apollo/client/cache';
import {createUploadLink} from 'apollo-upload-client';
// import '../../semantic-theme/semantic.less';

import EventGroupContainer from './components/eventGroup';

const cache = new InMemoryCache({});

const link = createUploadLink({
  uri: '/graphql',
  credentials: 'include',
});

const client = new ApolloClient({
  cache,
  link,
});

const Mypage = () => (
  <ApolloProvider client={client}>
    <EventGroupContainer />
  </ApolloProvider>
);

export default Mypage;

ReactDOM.render(<Mypage />, document.getElementById('event-group'));
